import React from "react";

const RestoIcon = () => {
return (
    <svg xmlns="http://www.w3.org/2000/svg" width="29.675" height="51.57"><g transform="translate(-274.049 -70)"><path fill="#FF5145" d="M296.295 88.544h2.622v33.026h-2.622z"/><ellipse fill="#FF5145" cx="6.119" cy="9.752" rx="6.119" ry="9.752" transform="translate(291.488 72.622)"/><path fill="#FF5145" d="M277.8 121.506l-.171-25.9-3.578-6.638.342-18.807h1.007l.589 14.136h.61L276.96 70h.514l.939 14.509h1.226l-.109-14.351.514-.158 1.405 14.4h.9l-.407-14.4h1.012l1.546 19.123-3.767 6.48v25.9z"/></g></svg>
)}

export default RestoIcon;
